import axios from 'axios';

import { FlowBuilderLibraryQuery } from '@/store/flowBuilder/flowBuilder.type';
import { Reel } from '@/types/reel.type';

export type FetchReelsPagination = {
    current_page: number;
    total: number;
    per_page: number;
    total_pages: number;
};

// NOTE: Example reel slugs are accepted as codes too
export async function fetchReelsBatch(codes: string[]): Promise<Reel[]> {
    const { data } = await axios.get<{ reels: Reel[] }>(
        route('api.internal.reels.batch', { codes }),
    );

    return data.reels;
}

export async function fetchLibraryReels(
    page: number,
    { search, direction }: FlowBuilderLibraryQuery,
    signal?: AbortSignal,
): Promise<{ reels: Reel[]; pagination: FetchReelsPagination }> {
    const { data } = await axios.get<{
        reels: Reel[];
        pagination: FetchReelsPagination;
    }>(
        route('api.internal.reels.index', {
            page,
            direction,
            search: search || undefined,
        }),
        { signal },
    );

    return data;
}
